import React, { forwardRef } from 'react'
import { DraggableContent } from './DraggableContent'

interface RuleRowProps {
    rules: any[]
    rule: Record<string, any>
    index: number
}

export const RuleRow = forwardRef<HTMLDivElement, RuleRowProps>(
    (props, ref) => {
        const { rules, rule, index: i, ...rest } = props

        return (
            <div
                ref={ref}
                key={rule.element_id + i}
                {...rest}
            >
                <DraggableContent
                    rule={rule}
                    index={i}
                    rules={rules}
                />
            </div>
        )
    })